export default function TrustStrip() {
  const items = [
    { icon: "ri-refresh-line", text: "Real-time comparison data" },
    { icon: "ri-file-chart-line", text: "Spreadsheet-based analysis" },
    { icon: "ri-time-line", text: "Updated daily pricing insights" },
    { icon: "ri-shield-check-line", text: "No bias, no fake reviews" },
  ];

  return (
    <section className="py-8 md:py-10 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div key={item.text} className="flex items-center gap-3 justify-center md:justify-start">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}